var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58984 18.4007C12.5658 18.2781 21.9269 19.9304 27.564 27.5199",
    stroke: "#2F3031",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58984 21.5449C11.7238 21.4671 19.1026 22.5167 23.5459 27.3379",
    stroke: "#2F3031",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58984 24.6231C10.7551 24.5841 15.853 25.1089 18.9229 27.5195",
    stroke: "#2F3031",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4102 21.5096C26.2449 21.4707 22.441 22.1088 22.3591 22.6005",
    stroke: "#2F3031",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4102 24.4406C26.2449 24.4017 25.6994 24.7389 25.4381 24.7383",
    stroke: "#2F3031",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4102 18.511C26.2449 18.4721 20.9601 19.3479 19.126 20.4217",
    stroke: "#2F3031",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2676 9.45801C19.3715 9.38438 19.5104 9.38435 19.6143 9.45801L25.3535 13.5264C25.4329 13.5826 25.4805 13.6742 25.4805 13.7715V18.6719L22.6982 19.1475L22.666 19.1533L22.6338 19.1621L22.3281 19.2441V14.8105H16.5312V19.5762L13.4014 18.7275V13.7715C13.4014 13.6743 13.4482 13.5826 13.5273 13.5264L19.2676 9.45801Z",
    stroke: "#2F3031",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightIcon);
export default __webpack_public_path__ + "static/media/insightIcon.c37ff3fe65ce9654ce3e880372e6cfb0.svg";
export { ForwardRef as ReactComponent };